const MessageType = {
    SUCCESS: "SUCCESS",
    ERROR: "ERROR",
    WARNING: 'WARNING'
}


export {
    MessageType
}